{
  "name": "mantine-vite-template",
  "private": true,
  "type": "module",
  "version": "0.1.38",
  "scripts": {
    "dev": "vite",
    "build": "tsc && vite build",
    "preview": "vite preview",
    "typecheck": "tsc --noEmit",
    "stylelint": "stylelint '**/*.css' --cache",
    "prettier": "prettier --check \"**/*.{ts,tsx}\"",
    "prettier:write": "prettier --write \"**/*.{ts,tsx}\"",
    "test": "npm run typecheck && npm run prettier && npm run stylelint && npm run build && playwright test --project=chromium"
  },
  "dependencies": {
    "@hello-pangea/dnd": "^18.0.1",
    "@mantine/carousel": "^9.7.1",
    "@mantine/charts": "^9.7.1",
    "@mantine/core": "^9.7.1",
    "@mantine/dates": "^9.7.1",
    "@mantine/dropzone": "^9.7.1",
    "@mantine/form": "^9.7.1",
    "@mantine/hooks": "^9.7.1",
    "@mantine/notifications": "^9.7.1",
    "@tabler/icons-react": "^3.49.0",
    "@tanstack/react-query": "^5.104.1",
    "@tanstack/react-query-devtools": "^5.104.1",
    "axios": "^1.20.0",
    "dayjs": "^1.11.23",
    "dotenv": "^18.0.6",
    "embla-carousel": "^8.6.0",
    "embla-carousel-react": "^8.6.0",
    "encrypt-storage": "^3.0.4",
    "i18next": "^26.4.2",
    "lodash": "^4.18.1",
    "react": "^19.3.0",
    "react-dom": "^19.3.0",
    "react-easy-crop": "^6.2.4",
    "react-ga4": "^3.0.1",
    "react-i18next": "^17.0.16",
    "react-query-auth": "^2.4.3",
    "react-router": "^8.4.0",
    "recharts": "3.10.1",
    "zod": "^4.6.5"
  },
  "devDependencies": {
    "@eslint/js": "^10.0.1",
    "@ianvs/prettier-plugin-sort-imports": "^4.7.1",
    "@playwright/test": "^1.64.0",
    "@tanstack/eslint-plugin-query": "^5.104.1",
    "@types/lodash": "^4.17.25",
    "@types/node": "^26.6.4",
    "@types/react": "^19.3.0",
    "@types/react-dom": "^19.3.0",
    "@vitejs/plugin-react": "^6.1.2",
    "axios-mock-adapter": "^2.1.0",
    "eslint": "^10.12.0",
    "eslint-config-prettier": "^10.1.8",
    "eslint-plugin-jsx-a11y": "^6.10.2",
    "eslint-plugin-react": "^7.37.5",
    "eslint-plugin-react-hooks": "^7.1.1",
    "identity-obj-proxy": "^3.0.0",
    "knip": "^6.40.0",
    "postcss": "^8.5.29",
    "postcss-preset-mantine": "1.18.0",
    "postcss-simple-vars": "^7.0.1",
    "prettier": "^3.9.9",
    "stylelint": "^17.16.0",
    "stylelint-config-standard-scss": "^17.0.0",
    "typescript": "^7.0.2",
    "typescript-eslint": "^8.71.1",
    "vite": "^8.3.3"
  },
  "packageManager": "yarn@4.18.1"
}
